import { render, staticRenderFns } from "./OrderSideBar.vue?vue&type=template&id=75b871fa"
import script from "./OrderSideBar.vue?vue&type=script&lang=js"
export * from "./OrderSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports